export const defaultCountries = [
  {
    code: "TM",
    country: {
      ru: "Туркменистан",
      en: "Turkmenistan",
      uz: "Turkmaniston",
      tm: "Türkmenistan",
    },
  },
  {
    code: "RU",
    country: {
      ru: "Российская Федерация (Россия)",
      en: "Russian Federation",
			uz: "Rossiya Federatsiyasi (Rossiya)",
      tm: "Russiýa Federasiýasy (Russiýa)",
    },
  },
  {
    code: "KZ",
    country: {
      ru: "Казахстан",
      en: "Kazakhstan",
			uz: "Qozog'iston",
      tm: "Gazagystan",
    },
  },
  {
    code: "TR",
    country: {
      ru: "Турция",
      en: "Turkey",
			uz: "Turkiya",
      tm: "Türkiýe",
    },
  },
  {
    code: "CN",
    country: {
      ru: "Китай",
      en: "China",
			uz: "Xitoy",
      tm: "Hytaý",
    },
  },
  {
    code: "TJ",
    country: {
      ru: "Республика Таджикистан",
      en: "Tajikistan",
			uz: "Tojikiston",
      tm: "Täjigistan Respublikasy",
    },
  },
  {
    code: "UZ",
    country: {
      ru: "Республика Узбекистан",
      en: "Uzbekistan",
			uz: "O'zbekiston Respublikasi",
      tm: "Özbegistan Respublikasy",
    },
  },
  {
    code: "KG",
    country: {
      ru: "Кыргызская Республика",
      en: "Kyrgyzstan",
			uz: "Qirg'iziston",
      tm: "Gyrgyz Respublikasy",
    },
  },
];
